<template >
  <section>
    <div style="background-color:white" class="assetCard">
      <div style="margin-top:20px">
        <el-button type="primary" v-print="printObj" style="float:left;margin-left: 10px;">打印</el-button>

        <!-- <el-button class="btn" type="info" @click="returnDeviceinfo" style="float:left;margin-left: 10px;">返回</el-button> -->

      </div>
      <div id="print" ref="printContent">
        <div ref="docxView"></div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import { assetCard } from '../../../api/api'
const docxPre = require('docx-preview')
window.JSZip = require('jszip')
export default {
  data() {
    return {
      printObj: {
        id: 'print',//id
        popTitle: "设备资产卡片",//自定义设置标题


      },
      fileUrl: ""
      
    }
  },
  methods: {
    showAssetCard() {
      let that = this
      let deviceData = this.$route.params.deviceData
      assetCard(deviceData).then(datas => {
        let blob = new Blob([datas], { type: "docx" })
        docxPre.renderAsync(blob, that.$refs.docxView)
      })
    },
    
  },
  created() {
    this.showAssetCard();
  }

}
</script>
<style lang="less" scoped>
.docx-wrapper {
  background: white !important;
  padding: 10px;
}

.docx {
  padding: 0pt 20.65pt 20pt 20.55pt !important;
  /* width: 789.9pt !important; */
  min-height: 0px !important;
  margin-top: -30px !important;
  margin-left: -10px !important;
}
</style>
<style>
.docx-wrapper {
  background: white !important;
  padding: 10px;
}

.docx-wrapper>section.docx {
  padding: 0pt 20.65pt 20pt 20.55pt !important;
  /* width: 789.9pt !important; */
  min-height: 0px !important;
  margin-top: -30px !important;
  margin-left: -10px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/device/components/AssetCard.vue